import { useState, useEffect } from "react";
import {
  postDoctors,
  postDoctorDetail,
  postContentDiag,
  getPageFloorElement,
  queryArticles,
  getPopularScienceArticles,
  getPatientConsultation,
  queryYellowPagesDoctorDetail,
  queryDoctorList,
} from "api/doctor-list";
import { getNethpHref } from '@jdhfe/seouifuncs/dist/tools/getNethpHref';
import { Helmet } from "react-helmet";
import { useLocation, useParams } from "react-router-dom";
import logo from "../../asset/img/login/logo.png";
import icon_right from "../../asset/img/login/icon_right.png";
import TripleHospital from "../../asset/img/login/Class-A-tertiary-hospital.png";
import Triple from "../../asset/img/login/Triple.png";
import selfSupport from "../../asset/img/login/self-support.png";
import Prescribible1 from "../../asset/img/login/Prescribible1.png";
import Group1 from "../../asset/img/login/Group1.png"; // 对勾
import Group2 from "../../asset/img/login/Group2.png"; // 资
import Group3 from "../../asset/img/login/Group3.png"; // 证
import Group4 from "../../asset/img/login/Group4.png"; // 人脸
import backText1 from "../../asset/img/login/backText1.png";
import backText2 from "../../asset/img/login/backText2.png";

import Telephone from "../../asset/img/login/Telephone.png"; // 电话
import video from "../../asset/img/login/video.png"; // 视频
import prvivateDoctor from "../../asset/img/login/prvivateDoctor.png"; //私人医生
import ImageText from "../../asset/img/login/ImageText.png"; // 图文
import OutpatientDepartment from "../../asset/img/login/OutpatientDepartment.png"; // 加号
import team from "../../asset/img/login/team.png"; //专家

import evaluate1 from "../../asset/img/login/evaluate1.png";
import evaluate2 from "../../asset/img/login/evaluate2.png";
import evaluate3 from "../../asset/img/login/evaluate3.png";
import evaluate4 from "../../asset/img/login/evaluate4.png";
import evaluate5 from "../../asset/img/login/evaluate5.png";

import QRCode from "qrcode.react";
import { message, Popover } from "antd";
import styles from "./index.less";
import OutPatientSch from "./outpatientScheduling";
import PatientConsultation from "./patientConsultation";
import PopularScienceArticles from "./PopularScienceArticles";
import RecommendedDoc from "./recommendedDoctor";
import TextArea from "antd/lib/input/TextArea";
import PyDocSchedule from "./outScheduling";
import { ErrorComp } from "components/error";
import PcseoRecommondCard from "@jdh-cargo/block-pcseo-recommond-card";
import { handleDoctorData, targetLink } from 'utils/index';
import { getQrCodeUrl } from "utils/doctor";
import { doctorNav } from "utils/hospital";
import { getNavigationBarDtoList } from "api/tab-bar";
import HospitalNav from "pages/hospital/components/Nav";
import { queryRecommendArticles, recommendContentQaGW } from "api/hospital";
// import { seoFooter } from "utils/seoFooter.js";

// 医生主页
const Doctor = () => {
  const params = useParams<Record<any, any>>();
  const [pageId, setPageId] = useState<any>();
  const [departData, setDepartData] = useState<any>();
  const [contentDiagData, setContentDiagData] = useState<any>();
  const [positiveDiagData, setPositiveDiagData] = useState<any>();
  const [browsecount, setBrowsecount] = useState<any>();
  const [ImageText1, setImageText1] = useState<any>();
  const [Telephone1, setTelephone1] = useState<any>();
  const [video1, setvideo1] = useState<any>();
  const [prvivateDoctor1, setprvivateDoctor1] = useState<any>();
  const [OutpatientDepartment1, setOutpatientDepartment1] = useState<any>();
  const [team1, setteam1] = useState<any>();
  const [idnexID, setIdnexID] = useState<any>(3);
  // 黄页医生
  const [pyContentDiagData, setPyContentDiagData] = useState<any>();
  const [pyContentOtherArt, setPyContentOtherArt] = useState<any>([]);
  // 黄页医生排班
  const [pyDoctorPeriodDTOS, setPyDoctorPeriodDTOS] = useState<any>([]);
  const [pyDoctorList, setPyDoctorList] = useState<any>([]);
  const [loading, setLoading] = useState(true);

  const [navList, setNavList] = useState<any[]>();
  const getNavigationBarDtoFunc = (baseNav?: any[]) => {
    const baseNavList = baseNav;
    // 后端控制tab的展示和链接
    getNavigationBarDtoList({ currentUrl: window.location.href }).then(
      (res: any) => {
        const realList = res?.map((item: any) => {
          const url = item.url;
          let cItem;
          try {
            const Url = new URL(url);
            const path = Url.pathname;
            cItem = baseNavList?.find((iitem) => iitem.url === path);
          } catch (e) {
            console.log(e);
          }
          return {
            ...cItem,
            ...item,
          };
        });
        setNavList(realList?.length ? realList : undefined);
        // setNavList(realList?.length ? realList : baseNavList);
      }
    ).catch(e=>{
      console.log(e)
      // setNavList(baseNavList);
    })
  };
  useEffect(()=>{
    if(pageId){
      const baseNav = doctorNav(`${pageId}`);
      // @ts-ignore
      // setNavList(baseNav);
      getNavigationBarDtoFunc(baseNav);
    }
  },[pageId]);

  const routerPath = useLocation();
  useEffect(() => {
    if (params.id) {
      setPageId(params.id);
      getinitFun(params.id);
      getPageFloorElementFun(params.id);
      queryArticles({
        docId: params.id,
        page: 1,
        pageSize: 10,
        witchContent: true,
      })
        .then((res: any) => {
          if (res?.data && res?.data.length > 0) {
            setBrowsecount(res.data);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, []);
  const getPageFloorElementFun = (doctorId: any) => {
    getPageFloorElement({
      genericParam: {
        queryParam: [
          {
            doctorId,
            pageNo: 1,
            pageSize: 10,
            diseases: [],
            tenantId: "JD8888",
            sortType: 1,
          },
          null,
        ],
      },
      floorName: "comment",
    }).then((res: any) => {
      setPositiveDiagData(res);
    })
  };
  const filterFun = (data: any, id: any) => {
    return (
      data &&
      data?.doctorServiceInfoList &&
      data?.doctorServiceInfoList
        ?.filter((q: any) => q.onSellStatus == 8)
        .filter((q: any) => q.serviceGroupId == id)
        .filter(
          (q: any) =>
            q.businessTypeId == 0 ||
            q.businessTypeId == 8 ||
            q.businessTypeId == 13 ||
            q.businessTypeId == 19 ||
            q.businessTypeId == 20 ||
            q.businessTypeId == 13
        )
    );
  };
  // 获取患友咨询信息
  const pyGetPatientConsultation = (secondDepartId: any) => {
    // getPatientConsultation(
    //   { "osName": "content", 
    //   "venderId": null, 
    //   "inquiryTenancyId": null,
    //    "tenantId": 287,
    //     "version": 9, 
    //     "methodName": "recommendContentQa435",
    //     "contentBusinessIds": [359],
    //     "contentDiag": { "displayFlag": 1 }, 
    //     "contentAttributesWithOr": [{ "attributeCode": "2", "attributeType": 5 }, { "attributeCode": "3", "attributeType": 5 }], 
    //     "departmentId": secondDepartId, 
    //     "pageSize": 10,
    //      "appId": "c59cb704c24245a58768efa1ca1b4940" 
    //     }
    // )
    recommendContentQaGW({
      "venderId": null, 
      "inquiryTenancyId": null,
       "tenantId": 287,
        "contentBusinessIds": [359],
        "contentDiag": { "displayFlag": 1 }, 
        "contentAttributesWithOr": [{ "attributeCode": "2", "attributeType": 5 }, { "attributeCode": "3", "attributeType": 5 }], 
        "departmentId": secondDepartId, 
        "pageSize": 10,
    })
    .then((res) => {
      // console.log(res);
      setPyContentDiagData(res);
    })
  };
  // 黄页科普文章
  const pyGetPopularScienceArticles = (secondDepartId: any) => {
    // getPopularScienceArticles(
    //   {
    //     "osName":"content",
    //     "venderId":null,
    //     "inquiryTenancyId":null,
    //     "tenantId":287,
    //     "version":9,
    //     "methodName":"recommendContentArticle428",
    //     "contentBusinessIds":[359],
    //     "departmentId":secondDepartId,
    //     "pageSize":10,
    //     "appId":"c59cb704c24245a58768efa1ca1b4940"
    //   }
    // )
    queryRecommendArticles({
      "venderId":null,
      "inquiryTenancyId":null,
      "tenantId":287,
      "version":9,
      "contentBusinessIds":[359],
      "departmentId":secondDepartId,
      "pageSize":10,
    })
    .then((res) => {
      setPyContentOtherArt(res);
    })
  }
  // 黄页医生详情 黄页 排班
  const pyqueryYellowPagesDoctorDetail = () => {
    queryYellowPagesDoctorDetail({
      yellowpagesDocId: params.id
    }).then((res: any) => {
      // data.yellowPagesDoctorPeriodDTOS
        // setPyDoctorPeriodDTOS(res?.yellowPagesDoctorPeriodDTOS);
        if (res?.secondDepartId) {
          pyGetPatientConsultation(res?.secondDepartId);
          pyGetPopularScienceArticles(res?.secondDepartId);
          pyqueryDoctorList(res?.secondDepartId);
        }
        setPyDoctorPeriodDTOS(res);
        setDepartData({
          ...res,
          doctorSource: 1,
          docGoodAt: res.docGoodat || '',
          titleName: res.teacherTitle,
          docId: res.yellowpagesDocId,
          doctorHeadImg: res.docHeadPic
        });
      }
    ).finally(() => setLoading(false));;
  }
  // 黄页医生 推荐列表
  const pyqueryDoctorList = (secondDepartmentId: any) => {
    queryDoctorList(
      {"pageSize":30,"pageIndex":1,"keyWords":{"secondDepartmentId":secondDepartmentId}}
    ).then((res:any) => {
      setPyDoctorList(res?.doctorList);
    })
  }
  const getinitFun = (id: any) => {
    if (id) {
      pyqueryYellowPagesDoctorDetail();
      postDoctorDetail({
        doctorId: id,
        queryServiceAndTag: true,
        queryYellowDoctor: true,
      }).then((res: any) => {
        if(res.doctorId){
          const resData:any = handleDoctorData(res);
          setDepartData(resData);
          // 黄页接口调用 doctorSource 
          // if (res.doctorSource == 1) {
          //   console.log('黄页来了=========》');
          //   pyGetPatientConsultation(res?.secondDepartId);
          //   pyGetPopularScienceArticles(res?.secondDepartId);
          //   pyqueryYellowPagesDoctorDetail();
          //   pyqueryDoctorList(res?.secondDepartId);
          // }
          if (resData?.doctorServiceInfoList) {
            // 图文
            setImageText1(filterFun(resData, 1));
            // Telephone 电话
            setTelephone1(filterFun(resData, 3) || filterFun(resData, 3001));
            //视频
            setvideo1(filterFun(resData, 2));
            // 私人医生
            if (filterFun(resData, 1008).length > 0) {
              setprvivateDoctor1(filterFun(resData, 1008));
            } else if (filterFun(resData, 1001).length > 0) {
              setprvivateDoctor1(filterFun(resData, 1001));
            } else if (filterFun(resData, 1002).length > 0) {
              setprvivateDoctor1(filterFun(resData, 1002));
            }
            // 加号
            setOutpatientDepartment1(filterFun(resData, 1005));
            // 专家团队
            setteam1(filterFun(resData, 1003));
          }
        }
      }).finally(() => setLoading(false));;
      
      postContentDiag({
        receptionDoctorId: id,
        pageSize: 10,
        tenantId: 287,
        ruletype: 3,
      }).then((res: any) => {
        setContentDiagData(res.data);
      });
      // seoFooter();
    }
  };

  const onClickOpen = (url?: any) => {
    if (url) {
      window.open(url);
    } else {
      window.open("/");
    }
  };
  const timeStampFun = (timeStamp: string | number | Date) => {
    const date = new Date(timeStamp);
    const year = date.getFullYear();
    const month = Number(date.getMonth()) + 1;
    const day = date.getDate();
    let hour: any = date.getHours();
    if (hour < 10) {
      hour = "0" + hour;
    }
    let minute: any = date.getMinutes();
    if (minute < 10) {
      minute = "0" + minute;
    }
    return year + "." + month + "." + day;
  };
  const qrCodeUrl = getQrCodeUrl(pageId);
  const content = (
    <div className={styles.overbookingCodebotton}>
      <QRCode value={qrCodeUrl} size={80} />
      <div>
        <h3>扫码关注医生</h3>
        <h6>关注{departData?.docName}医生，方便随时提问</h6>
      </div>
    </div>
  );
  const content1 = (
    <div className={styles.overbookingCodebotton1}>
      <QRCode value={"https://m.jdh.com/doctor/" + pageId} size={80} />
      <div>
        <h3>手机一扫</h3>
        <h6>快速下单</h6>
      </div>
    </div>
  );
  const onClickhref = async (url: any, isNotJumpUrl?: boolean) => {
    // isJumpUrl - 医院名称屏蔽处理 部分医院不做跳转 true-禁止跳转
    if (isNotJumpUrl) {
      console.log('=====禁止跳转=====')
      return;
    }
    targetLink(url);
  };
  let doctorTagDTOMap =
    departData?.doctorTagDTOMap &&
      Object.keys(departData?.doctorTagDTOMap).length > 0 &&
      departData?.doctorTagDTOMap["1"]
      ? departData?.doctorTagDTOMap["1"].filter((val: any) => {
        return val.dictionaryType == 1 && val.dictionaryId == 10073;
      })
      : "";
  const textParagraphContent = (data: any) => {
    return (
      data &&
      data.length > 0 &&
      data
        .map((val: any) => {
          if (
            val?.body?.type == "text" &&
            val?.from?.app == "jd.doctor" &&
            val?.body?.content
          ) {
            return val?.body?.content;
          }
        })
        .filter((itme: any) => {
          return itme && itme.trim();
        })
        .join("")
    );
  };
  const docTitle =  ("【" +
  departData?.docName +
  "】" +
  departData?.hospitalName +
  "_网上预约挂号_图文问诊/电话问诊/门诊加号/在线问诊_京东健康互联网医院") 
  const pyDocTitle = (
  departData?.docName 
  + "医生预约挂号-出诊时间-" + 
  departData?.hospitalName + "-" + departData?.departName +
  "-京东健康互联网医院") 
  document.title = departData?.doctorSource == 0 ? docTitle :  pyDocTitle ;

  const des =  (departData?.docName + "," +departData?.hospitalName +
   "," + departData?.departName +"主任医师,擅长医治:" + departData?.docGoodAt);

  const pyDes = ("京东健康为您提供" + departData?.hospitalName + 
  departData?.docName + "的介绍、出诊时间、评价、预约挂号等，百万患者真实评价及就医分享，帮您了解"
   + departData?.docName + "执业经历及擅长治疗疾病，助您找到合适自己的医生在线咨询、预约挂号;");

  const docuDes = departData?.doctorSource == 0 ? des :  pyDes ;
  document
    .querySelector('meta[name="description"]')
    ?.setAttribute(
      "content",
        docuDes
    );
  
  const dkey = ( departData?.docName +
   "," +
  departData?.hospitalName +
  "," +
  departData?.departName +
  "主任医师");

  const pydkey = ( departData?.docName +
    "," +
   departData?.hospitalName + departData?.docName +
   "," +
   departData?.docName +
   "预约挂号");

 const docukeywork = departData?.doctorSource == 0 ? dkey :  pydkey ;
  document
    .querySelector('meta[name="keywords"]')
    ?.setAttribute(
      "content",
      docukeywork
    );
  return (
    <div className={styles.doctor}>
      { !loading && !departData && <ErrorComp /> }
      {/* // top 医生信息*/}
      { !loading && departData &&
        <div className={styles.qalistBack}>
          {/* 当前位置： */}
          <div className={styles.describe}>
            <div>
              {/* 当前位置： */}
              <i
                data-a-href="/"
                onClick={() => {
                  onClickOpen();
                }}
                data-a-nofollow="true"
              >
                首页
              </i>
              <span>{">"}</span>
              {departData?.hospitalName && departData?.docName ? (
                <>
                  <a
                  onClick={() => {
                    onClickOpen("/hospital/" + departData?.hospitalId);
                  }}
                  data-a-href={"/hospital/" + departData?.hospitalId}
                  >{departData?.hospitalName}</a>
                  {departData?.hospitalName && <span>{">"}</span>}
                  <a data-tag-h1
                  data-a-href={
                    departData?.doctorSource === 1 ? `/yellowdoctor/${pageId}` : `/doctor/${pageId}`
                  }
                  onClick={() => {
                    let url = `/doctor/${pageId}`;
                    if (departData?.doctorSource === 1) {
                      url = `/yellowdoctor/${pageId}`;
                    }
                    onClickOpen(url);
                  }}
                  >{departData?.docName}</a>
                </>
              ) : null}
            </div>
          </div>
          {/* 医生信息 */}
          {departData && (
            <div className={styles.qalistBackBox}>
              <div className={styles.qalistBackList}>
                <div className={styles.doctorImg}>
                  <img
                    src={
                      "https://image.healthjd.com/nethpim/" +
                      departData?.doctorHeadImg
                    }
                    alt={departData?.docName}
                  />
                </div>
                <div className={styles.doctorBox}>
                  <div className={styles.doctorBoxTop}>
                    <a
                    onClick={() => {
                      onClickhref("/doctor/" + pageId);
                    }}
                    >{departData?.docName}</a>
                    { departData?.titleName && <span>{departData?.titleName}</span> }
                    {departData?.selfSupport && (
                      <img
                        className={styles.selfSupport}
                        src={selfSupport}
                        alt=""
                      />
                    )}
                    {departData?.operationalOpenRxStatus === 1 && (
                      <img
                        className={styles.operationalOpenRxStatus}
                        src={Prescribible1}
                        alt=""
                      />
                    )}
                    {departData?.hospitalGrade === 3 && (
                      <img className={styles.hospitalGrade} src={Triple} alt="" />
                    )}
                  </div>
                  <div className={styles.doctorBoxTop1}>
                    <a
                      style={{cursor: departData?.hospitalReplace ? 'default' : 'pointer'}}
                      onClick={() => onClickhref("/hospital/" + departData?.hospitalId, departData?.hospitalReplace)} 
                      data-a-href={"/hospital/" + departData?.hospitalId}
                    >{departData?.hospitalName}</a>
                    {' '}
                    <a
                      onClick={() => onClickhref("/hospital/department/" + departData?.hospitalId + '-' + departData?.secondDepartId)}
                      data-a-href={"/hospital/department/" + departData?.hospitalId + '-' + departData?.secondDepartId}
                    >{departData?.secondDepartName}</a>
                  </div>
                  <div className={styles.doctorBoxTop2}>
                    执业证：{departData?.practiceCode || "暂无资料"}
                  </div>
                </div>
              </div>
              {departData?.doctorSource == 0 &&
                (departData?.qualificationsCode ||
                  departData?.practiceCode ||
                  doctorTagDTOMap?.length > 0) && (
                  <div className={styles.qalistBackRight}>
                    <div className={styles.qalistBackRightText}>实名认证</div>
                    {departData?.qualificationsCode && (
                      <div className={styles.qalistBackRightList}>
                        <div className={styles.qalistBackRightBox}>
                          <img src={Group2} alt="" />
                          <div>
                            <span>医师资格证</span>
                          </div>
                        </div>
                        <div className={styles.qalistBackRightBox1}>
                          <img src={Group1} alt="" />
                        </div>
                      </div>
                    )}
                    {departData?.practiceCode && (
                      <div className={styles.qalistBackRightList}>
                        <div className={styles.qalistBackRightBox}>
                          <img src={Group3} alt="" />
                          <div>
                            <span>医师执业照</span>
                            <p>执业证书编号:{departData?.practiceCode}</p>
                          </div>
                        </div>
                        <div className={styles.qalistBackRightBox1}>
                          <img src={Group1} alt="" />
                        </div>
                      </div>
                    )}
                    {doctorTagDTOMap?.length > 0 && (
                      <div className={styles.qalistBackRightList}>
                        <div className={styles.qalistBackRightBox}>
                          <img src={Group4} alt="" />
                          <div>
                            <span>人脸识别认证</span>
                            <p>所有服务均由医生本人提供</p>
                          </div>
                        </div>
                        <div className={styles.qalistBackRightBox1}>
                          <img src={Group1} alt="" />
                        </div>
                      </div>
                    )}
                  </div>
                )}
            </div>
          )}
        </div>
      }
      {/* 导航 */}
      { !loading && departData &&
        <div className={styles.nav}>
          <HospitalNav pageId={pageId} navList={navList} />
        </div>
      }

      {/* 内容 */}
      { !loading && departData &&
        <div className={styles.content}>
          {/* 科普文章 */}
          <div className={styles.consultationNo}>
            {browsecount &&
              browsecount.length > 0 &&
              browsecount.map((v: any, idnex: any) => {
                return (
                  <div key={idnex}>
                    <span> {v.title}</span>
                    {/* <p dangerouslySetInnerHTML={{ __html: v.content }}></p> */}

                    {v.content}
                  </div>
                );
              })}
          </div>
          {/* 左 */}
          <div className={styles.left}>
            {/* 医生介绍 */}
            {(departData?.docIntro || departData?.docGoodAt) && (
              <div className={styles.jianjieList}>
                {departData?.docGoodAt && (
                  <div
                    className={styles.jianjieList1}
                    onClick={() => {
                      window.location.href = "/jianjie/" + pageId;
                    }}
                  >
                    <div className={styles.jianjieListTop}>
                      <div className={styles.jianjieListTopText}>
                        <img src={backText1} alt="专业擅长" />
                      </div>
                      <div className={styles.jianjieListTopInfo}>
                        <span
                          data-a-href={"/jianjie/" + pageId}
                          data-a-nofollow="true"
                        >
                          点击查看
                        </span>
                        <img src={icon_right} alt="" />
                      </div>
                    </div>
                    <div className={styles.jianjieListText}>
                      {departData?.docGoodAt}
                    </div>
                  </div>
                )}

                {departData?.docIntro && (
                  <div
                    className={styles.jianjieList2}
                    onClick={() => {
                      window.location.href = "/jianjie/" + pageId;
                    }}
                  >
                    <div className={styles.jianjieListTop}>
                      <div className={styles.jianjieListTopText}>
                        <img src={backText2} alt="个人简介" />
                      </div>
                      <div className={styles.jianjieListTopInfo}>
                        <span
                          data-a-href={"/jianjie/" + pageId}
                          data-a-nofollow="true"
                        >
                          点击查看
                        </span>
                        <img src={icon_right} alt="" />
                      </div>
                    </div>
                    <div className={styles.jianjieListText}>
                      {departData?.docIntro}
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* 黄页线下排班 */}
          { pyDoctorPeriodDTOS &&
          //  <OutPatientSch 
          //   psName = {departData?.docName }
          //   pyDoctorPeriodDTOS = {pyDoctorPeriodDTOS}
          //   />
          <PyDocSchedule 
          yellowDoctorInfo={pyDoctorPeriodDTOS}
          psName={departData?.docName}
          />

          }
            {/* 黄页患友问诊 */}
          { pyContentDiagData && pyContentDiagData.length > 0 &&  
          <PatientConsultation
              departData={departData}
              pageId={pageId}
              contentDiagData={pyContentDiagData}
              icon_right={icon_right}
              evaluate5={evaluate5}
            />
          }
            {/* 黄页科普文章 */}
            {
            pyContentOtherArt && pyContentOtherArt.length> 0 &&
            <PopularScienceArticles 
              icon_right={icon_right}
              contentOtherArt= {pyContentOtherArt}
              evaluate5={evaluate5}
              secondDepartName={departData?.secondDepartName}
            />
            }
            {/* 问诊服务 */}
            { departData?.doctorSource != 1 &&  departData?.docName && (
              <div className={styles.service}>
                <div className={styles.serviceTit}>
                  {departData?.docName}的问诊服务
                </div>
                <div className={styles.serviceUl}>
                  {/* 图文 */}
                  <Popover content={content1}>
                    <div className={styles.serviceLi}>
                      <img src={ImageText} alt="" />
                      <div className={styles.serviceLiRight}>
                        <div className={styles.serviceUlTitle}>图文问诊</div>
                        <div className={styles.serviceUlText}>
                          {ImageText1 && ImageText1?.length > 0 ? (
                            <>
                              <i>¥</i>
                              <span>{ImageText1[0].jdPrice}</span>
                              <span className={styles.serviceUlTextSpan}>
                                /48小时
                              </span>
                            </>
                          ) : (
                            <span className={styles.serviceUlTextSpan}>
                              暂未开通
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </Popover>
                  {/* 电话 */}
                  <Popover content={content1}>
                    <div className={styles.serviceLi}>
                      <img src={Telephone} alt="" />
                      <div className={styles.serviceLiRight}>
                        <div className={styles.serviceUlTitle}>电话问诊</div>
                        <div className={styles.serviceUlText}>
                          {Telephone1 && Telephone1?.length > 0 ? (
                            <>
                              <i>¥</i>
                              <span>{Telephone1[0].jdPrice}</span>
                              <span className={styles.serviceUlTextSpan}>起</span>
                            </>
                          ) : (
                            <span className={styles.serviceUlTextSpan}>
                              暂未开通
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </Popover>
                  {/* 门诊加号 */}

                  {
                    <Popover content={content1}>
                      <div className={styles.serviceLi}>
                        <img src={OutpatientDepartment} alt="" />
                        <div className={styles.serviceLiRight}>
                          <div className={styles.serviceUlTitle}>门诊加号</div>
                          <div className={styles.serviceUlText}>
                            {OutpatientDepartment1 &&
                              OutpatientDepartment1?.length > 0 ? (
                              <span className={styles.serviceUlTextSpan}>
                                免费预约
                              </span>
                            ) : (
                              <span className={styles.serviceUlTextSpan}>
                                暂未开通
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </Popover>
                  }
                  {/* 私人医生 */}
                  {prvivateDoctor1 && prvivateDoctor1?.length > 0 && (
                    <Popover content={content1}>
                      <div className={styles.serviceLi}>
                        <img src={prvivateDoctor} alt="" />
                        <div className={styles.serviceLiRight}>
                          <div className={styles.serviceUlTitle}>私人医生</div>
                          <div className={styles.serviceUlText}>
                            <i>¥</i>
                            <span>{prvivateDoctor1[0].jdPrice}</span>
                            <span className={styles.serviceUlTextSpan}>起</span>
                          </div>
                        </div>
                      </div>
                    </Popover>
                  )}
                  {/* 视频 */}
                  {video1 && video1?.length > 0 && (
                    <Popover content={content1}>
                      <div className={styles.serviceLi}>
                        <img src={video} alt="" />
                        <div className={styles.serviceLiRight}>
                          <div className={styles.serviceUlTitle}>视频问诊</div>
                          <div className={styles.serviceUlText}>
                            {video1 && video1?.length > 0 ? (
                              <>
                                <i>¥</i>
                                <span>{video1[0].jdPrice}</span>
                                <span className={styles.serviceUlTextSpan}>
                                  /15分钟
                                </span>
                              </>
                            ) : (
                              <span className={styles.serviceUlTextSpan}>
                                暂未开通
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </Popover>
                  )}
                  {/* 专家团队 */}
                  {team1 && team1?.length > 0 && (
                    <Popover content={content1}>
                      <div className={styles.serviceLi}>
                        <img src={team} alt="" />
                        <div className={styles.serviceLiRight}>
                          <div className={styles.serviceUlTitle}>专家团队</div>
                          <div className={styles.serviceUlText}>
                            <i>¥</i>
                            <span>{team1[0].jdPrice}</span>
                            <span className={styles.serviceUlTextSpan}>起</span>
                          </div>
                        </div>
                      </div>
                    </Popover>
                  )}
                </div>
              </div>
            )}
            {/* 患者评价 */}
          {positiveDiagData?.evaluationDTOList?.length ? departData?.doctorSource != 1 && 
              <div className={styles.evaluate}>
              <div className={styles.evaluateTit}>
                <div className={styles.evaluateTitText}>
                  {departData?.docName}的患者评价
                </div>
                <a
                  className={styles.evaluateTitTopInfo}
                  href={"/dianping/" + pageId}
                >
                  <span
                    data-a-nofollow="true"
                    data-a-href={"/dianping/" + pageId}
                  >
                    点击查看
                  </span>
                  <img src={icon_right} alt="" />
                </a>
              </div>
              <div className={styles.evaluateTop}>
                <div className={styles.evaluateTopLeft}>
                  <img src={evaluate1} alt="" />
                  <div className={styles.evaluateTopLeftText}>
                    {positiveDiagData && (
                      <p>
                        {positiveDiagData?.positive * 100 || "暂无评价"}
                        {positiveDiagData?.positive ? <span>%</span> : null}
                      </p>
                    )}

                    <h4>医生好评率</h4>
                  </div>
                </div>
                <img className={styles.evaluate2img} src={evaluate2} alt="" />
                <div className={styles.evaluateTopRight}>
                  <div className={styles.evaluateTopRight1}>
                    <h3>回复质量</h3>
                    <div>
                      <p
                        style={{
                          width:
                            positiveDiagData &&
                            positiveDiagData?.replyQualityPositive * 100 + "%",
                        }}
                      ></p>
                    </div>
                    {positiveDiagData &&
                      positiveDiagData?.replyQualityPositive ? (
                      <span>
                        {positiveDiagData?.replyQualityPositive * 100 + "%好评"}
                      </span>
                    ) : (
                      <span>暂无评价</span>
                    )}
                  </div>
                  <div className={styles.evaluateTopRight1}>
                    <h3>服务态度</h3>
                    <div>
                      <p
                        style={{
                          width:
                            positiveDiagData &&
                            positiveDiagData?.serviceAttitudePositive * 100 + "%",
                        }}
                      ></p>
                    </div>
                    {positiveDiagData &&
                      positiveDiagData?.serviceAttitudePositive ? (
                      <span>
                        {positiveDiagData?.serviceAttitudePositive * 100 +
                          "%好评"}
                      </span>
                    ) : (
                      <span>暂无评价</span>
                    )}
                  </div>
                  <div
                    className={`${styles.evaluateTopRight1} ${styles.evaluateTopRight2}`}
                  >
                    <h3>回复速度</h3>
                    <div>
                      <p
                        style={{
                          width:
                            positiveDiagData &&
                            positiveDiagData?.replySpeedPositive * 100 + "%",
                        }}
                      ></p>
                    </div>
                    {positiveDiagData && positiveDiagData?.replySpeedPositive ? (
                      <span>
                        {positiveDiagData?.replySpeedPositive * 100 + "%好评"}
                      </span>
                    ) : (
                      <span>暂无评价</span>
                    )}
                  </div>
                </div>
              </div>
              {/* teb切换 写死的第一个高亮 */}
              <div className={styles.evaluateTeb}>
                {positiveDiagData &&
                  positiveDiagData?.evaluationDTOList &&
                  positiveDiagData?.evaluationDTOList.length > 0 &&
                  positiveDiagData?.diseaseLabels.map((val: any, index: any) => {
                    return (
                      <a
                        className={`${styles.evaluateTebBtn} ${index == 0 ? styles.evaluateTebBtnactive : ""
                          }`}
                        data-a-href={
                          index == 0
                            ? "/dianping/" + pageId
                            : "/dianping/" + pageId + "_" + index
                        }
                        key={index}
                        onClick={() => {
                          index == 0
                            ? (window.location.href = "/dianping/" + pageId)
                            : (window.location.href =
                              "/dianping/" + pageId + "_" + index);
                        }}
                      >
                        {val.disease}
                      </a>
                    );
                  })}
              </div>
              {/* 患者评价列表 */}
              <div className={styles.evaluateList}>
                <ul>
                  {positiveDiagData &&
                    positiveDiagData?.evaluationDTOList &&
                    positiveDiagData?.evaluationDTOList.length > 0 ? (
                    positiveDiagData?.evaluationDTOList.map(
                      (val: any, idnex: any) => {
                        if (idnex < idnexID) {
                          return (
                            <li key={idnex}>
                              <div className={styles.evaluateListTop}>
                                <div className={styles.evaluateListTopLeft}>
                                  <div className={styles.evaluateListTopName}>
                                    {val.userNickName}
                                  </div>
                                  <span />
                                  <div className={styles.evaluateListTopLeftImg}>
                                    {[1, 2, 3, 4, 5].map(
                                      (itme: any, index: any) => {
                                        if (itme <= val.compositeScore) {
                                          return (
                                            <img
                                              key={index}
                                              src={evaluate3}
                                              alt=""
                                            />
                                          );
                                        } else {
                                          return (
                                            <img
                                              key={index}
                                              src={evaluate4}
                                              alt=""
                                            />
                                          );
                                        }
                                      }
                                    )}
                                  </div>
                                  <div className={styles.evaluateListTopEvaluea}>
                                    回复质量：{val.replyQualityScoreDesc}
                                    <span />
                                    服务态度：{val.serviceAttitudeScoreDesc}
                                    <span />
                                    回复速度：{val.replySpeedScoreDesc}
                                  </div>
                                </div>
                                <div className={styles.evaluateListTopRight}>
                                  {timeStampFun(val.created)}
                                </div>
                              </div>
                              <div className={styles.evaluateListText}>
                                {val.content || val?.diseaseDescription || "此用户未填写评价内容"}
                              </div>
                              <div className={styles.evaluateListButtom}>
                                {/* {val?.diseaseDescription && (
                                  <p>确诊疾病：{val?.diseaseDescription}</p>
                                )} */}
                                {val?.serviceTypeName && (
                                  <span>{val.serviceTypeName}</span>
                                )}
                              </div>
                            </li>
                          );
                        }
                      }
                    )
                  ) : (
                    <li className={styles.serviceTypeName}>暂无患者评价</li>
                  )}
                </ul>
              </div>
              {/* 展开更多 */}
              <div className={styles.evaluateListMore}>
                <p
                  onClick={() => {
                    if (idnexID < 9) {
                      setIdnexID(10);
                    }
                  }}
                >
                  {positiveDiagData &&
                    positiveDiagData?.evaluationDTOList &&
                    positiveDiagData?.evaluationDTOList.length > 2 &&
                    idnexID < 9 ? (
                    <>
                      <span>展开更多</span>
                      <img src={evaluate5} alt="" />
                    </>
                  ) : null}
                </p>
              </div>
              </div> 
          : null} 
            {/* 问诊记录 */}
            {contentDiagData?.length ? departData && departData?.doctorSource != 1  && (
              <div className={styles.consultationList}>
                <div className={styles.consultationListTit}>
                  <div>{departData?.docName}医生的问诊记录</div>
                  <a
                    className={styles.consultationListTitInfo}
                    href={"/qalist/" + pageId}
                  >
                    <span
                      data-a-href={"/qalist/" + pageId}
                      data-a-nofollow="true"
                    >
                      查看全部
                    </span>
                    <img src={icon_right} alt="" />
                  </a>
                </div>
                {contentDiagData && contentDiagData.length > 0 ? (
                  <ul>
                    {contentDiagData.map((itme: any, index: any) => {
                      return (
                        <li
                          key={index}
                          onClick={() => {
                            window.open(
                              window.location.origin +
                              "/qa" +
                              "/" +
                              itme?.contentDiags[0]?.diagId
                            );
                          }}
                        >
                          <div className={styles.consultationNo}>
                            {itme?.contentParagraphs.map(
                              (v: any, idnex1: any) => {
                                try {
                                  let text: any = textParagraphContent(
                                    JSON.parse(v.paragraphContent)
                                  );
                                  return (
                                    <div key={idnex1}>
                                      {(itme?.contentName + text).substring(0, 100)}
                                    </div>
                                  );
                                } catch (error) {
                                  console.log(error, 'error')
                                }
                              }
                            )}
                          </div>
                          <div className={styles.consultationListTop}>
                            <div
                              className={styles.consultationListTopText}
                              data-a-href={"/qa/" + itme?.contentDiags[0]?.diagId}
                            >
                              {itme?.contentName}
                            </div>
                            <div className={styles.consultationListTopInfo}>
                              <span
                                data-a-href={
                                  "/qa/" + itme?.contentDiags[0]?.diagId
                                }
                                data-a-nofollow="true"
                              >
                                点击查看
                              </span>
                              <img src={icon_right} alt="" />
                            </div>
                          </div>
                          <div className={styles.consultationListBon}>
                            <div className={styles.consultationListBonLeft}>
                              <div
                                className={styles.consultationListBonLeftText1}
                              >
                                <h3>总交流次数</h3>
                                <h5>
                                  {itme?.contentDiags[0]?.doctorExchangeCount +
                                    itme?.contentDiags[0]?.patientExchangeCount ||
                                    0}
                                </h5>
                              </div>
                              <div
                                className={styles.consultationListBonLeftLine}
                              />
                              <div
                                className={styles.consultationListBonLeftText2}
                              >
                                <h3>医生回复次数</h3>
                                <h5>
                                  {itme?.contentDiags[0]?.doctorExchangeCount ||
                                    0}
                                </h5>
                              </div>
                            </div>
                            <div className={styles.consultationListBonInfo}>
                              <span>患者：</span>
                              <h4>
                                {itme?.contentDiags[0]?.patientSex == 1
                                  ? "男 "
                                  : "女 "}
                                {itme?.contentDiags[0]?.patientAge || 0}
                              </h4>
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <div className={styles.consultationListNo}>暂无问诊记录</div>
                )}
              </div>
            )
            : null}
          </div>
          {/* 右 */}
          <div className={styles.right}>
            <div className={styles.rightFloat}>
              {/* 黄页医生推荐 */}
              {
                pyDoctorList && pyDoctorList.length > 0 
                && (
                  <div className={styles.pydoctorList}>
                    <div className={styles.doctorInfoTit}>{departData?.secondDepartName}推荐医生</div>
                    {
                      pyDoctorList?.map((item: any, index: any) => {
                        if (index < 10) {
                        return (
                          <RecommendedDoc
                            key={item?.lowestSku}
                            item={item}
                            icon_right={icon_right}
                          />);
                        }
                      })
                    }
                  </div>
                ) 
              }
              {/* 黄页医生推荐seo */}
              {
                pyDoctorList && pyDoctorList.length > 0 
                && (
                  <div className={styles.seopydoctorLists}>
                    {/* <div className={styles.doctorInfoTit}>{departData?.secondDepartName}推荐医生</div> */}
                    {
                      pyDoctorList?.map((item: any, index: any) => {
                        // if (index < 10) {
                        return (
                          <RecommendedDoc
                            key={item?.lowestSku}
                            item={item}
                            icon_right={icon_right}
                          />);
                        // }
                      })
                    }
                  </div>
                ) 
              }
              {/* 快速向专家提问 */}
              {departData && departData.doctorSource == 1&& (
                <PcseoRecommondCard />
              )}
              {departData && departData.doctorSource == 0&& (
                <div className={styles.rightdoctor}>
                  <h2>医生成就</h2>
                  <div className={styles.rightdoctorCont}>
                    <div className={styles.rightdoctorCont1}>
                      <span>
                        {departData?.patientEvaluationRate?.split('%')?.[0] || "暂无"}
                        <i>{departData?.patientEvaluationRate ? '%' : ""}</i>
                      </span>
                      <p>好评率</p>
                    </div>
                    <div className={styles.rightdoctorCont2} />
                    <div className={styles.rightdoctorCont1}>
                      <span>{departData?.receivePatientNum || "暂无"}</span>
                      <p>接诊人数</p>
                    </div>
                    <div className={styles.rightdoctorCont2} />
                    <div className={styles.rightdoctorCont1}>
                      <span>
                        {departData?.averageResponseTimeDTO?.averageResponseTime || "暂无"}
                        <i>
                          {departData?.averageResponseTimeDTO?.timeUnit || ""}
                        </i>
                      </span>
                      <p>平均响应</p>
                    </div>
                  </div>
                </div>
              )}
              {departData?.docName && (
                <div className={styles.overbookingCode}>
                  <QRCode
                    value={qrCodeUrl}
                    size={80}
                  />
                  <div>
                    <h3>扫码关注医生</h3>
                    <h6>关注{departData?.docName}医生，方便随时提问</h6>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      }
      {/* // 底部线 */}
      <div className={styles.footerLine}>
        <p></p>
      </div>
      <div className={styles.footerData} id="m_common_bottom" />
      {/* 底部 */}
      <div className={styles.bottom}>
        <div className={styles.bottomDoctorInfo}>
          {departData && (
            <>
              <img
                src={
                  "https://image.healthjd.com/nethpim/" +
                  departData?.doctorHeadImg
                }
                alt={departData?.docName}
              />
              <div className={styles.doctorInfoImgRight}>
                <div className={styles.doctorInfoImgTop}>
                  <div className={styles.doctorInfoImgTopName}>
                    {departData?.docName}
                  </div>
                  <span>{departData?.titleName}</span>
                  {/* <span>{departData?.departName}</span> */}
                  <p>已认证</p>
                </div>
                <div className={styles.doctorInfoImgBotton}>
                  {departData?.hospitalGrade === 3 && (
                    <img src={TripleHospital} alt="" />
                  )}
                  <p>
                    {departData?.hospitalName} {departData?.secondDepartName}
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
        <div className={styles.bottomBtn}>
          <Popover content={content}>
            <button className={styles.bottomBtn1}>立即咨询</button>
          </Popover>
          <Popover content={content}>
            <button className={styles.bottomBtn2}>
              扫码关注医生，方便随时咨询
            </button>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default Doctor;
